import React from 'react'
import { Link, graphql } from 'gatsby'
import { kebabCase } from 'lodash'
import { GatsbyImage } from 'gatsby-plugin-image'
import AudioPlayer from '../components/audioPlayer'
import DefaultLayout from '../components/layout'
import SEO from '../components/seo'
import { removeHtmlTags, extractUniqueChineseCharacters } from '../utils/utils'
import 'katex/dist/katex.min.css'
import Hanzi from '../components/hanzi'
import TextSpeech from '../components/textspeech'

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark

    return (
      <DefaultLayout>
        <SEO title={post.frontmatter.title} description={post.excerpt} />
        <div className="clearfix post-content-box">
          <article className="article-page">
            <div className="page-content">
              {post.frontmatter.img && (
                <div className="page-cover-image">
                  <figure>
                    <GatsbyImage
                      image={
                        post.frontmatter.img.childImageSharp.gatsbyImageData
                      }
                      className="page-image"
                      key={
                        post.frontmatter.img.childImageSharp.gatsbyImageData.src
                      }
                      alt=""
                    />
                  </figure>
                </div>
              )}
              <div className="wrap-content">
                <header className="header-page">
                  <h1 className="page-title">{post.frontmatter.title}</h1>
                  <div className="page-date">
                    <span>{post.frontmatter.author}</span>
                  </div>
                </header>
                <div className="poem-body">
                  <div
                    className="poem-body-text"
                    dangerouslySetInnerHTML={{ __html: post.html }}
                  />
                  {post.frontmatter.body_audio == null ||
                  post.frontmatter.body_audio == 'null' ? (
                    <AudioPlayer src="" />
                  ) : (
                    <AudioPlayer src={post.frontmatter.body_audio.publicURL} />
                  )}
                  {post.frontmatter.content != '' &&
                  post.frontmatter.content != null &&
                  post.frontmatter.content != 'null' ? (
                    <TextSpeech text={post.frontmatter.content}></TextSpeech>
                  ) : (
                    <TextSpeech
                      text={removeHtmlTags(post.excerpt)}
                    ></TextSpeech>
                  )}
                </div>
                <div className="hanzi-writer">
                  {(post.frontmatter.characters != null) &
                  (post.frontmatter.characters != 'null') &
                  (post.frontmatter.characters != '') ? (
                    <Hanzi data={post.frontmatter.characters}></Hanzi>
                  ) : (
                    <Hanzi
                      data={extractUniqueChineseCharacters(
                        removeHtmlTags(post.excerpt)
                      )}
                    ></Hanzi>
                  )}
                </div>
                <div className="page-footer">
                  <div className="page-tag">
                    {post.frontmatter.tags &&
                      post.frontmatter.tags.map((tag) => (
                        <span key={tag}>
                          <Link className="tag" to={`/tags/${kebabCase(tag)}/`}>
                            # {tag}
                          </Link>
                        </span>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </DefaultLayout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        author
        characters
        content
        tags
        img {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              layout: FULL_WIDTH
              formats: [AUTO, AVIF, WEBP]
            )
          }
        }
        body_audio {
          publicURL
        }
      }
    }
  }
`
